import { css } from 'lit';

export const projectCreateViewStyles = css`

  :host {
    background: linear-gradient(180deg, var(--yellow-2) 0, var(--gray-1) 200px);
  }

  view-content {
    padding-top: 5rem;
  }

  header-bar {
    --header-icon-color: var(--yellow-3);
    --header-icon-opacity: 0.3;
    --header-icon-bottom-position: -3rem;
    --header-bar-padding-trim: 5.5rem;
  }

  .form-footer {
    margin: 2.5rem 0;
    font-style: italic;
  }

  p.subtitle.primary {
    margin-top:0px;
    margin-bottom: 0px;
  }
`;
